import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  text: {
    marginTop: spacing(1),
    marginBottom: spacing(1),
    color: colors.text.secondary,
  },
  divider: {
    marginTop: spacing(2),
    marginBottom: spacing(2),
  },
});

export default styles;
